import { IPerformer } from '@interfaces/performer';
import { Tabs } from 'antd';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import {
  AiOutlineFire, AiOutlineVideoCamera, AiOutlinePicture, AiOutlineShopping
} from 'react-icons/ai';

const PostTab = dynamic(() => import('./post-tab'));
const GalleryTab = dynamic(() => import('./gallery-tab'));
const ProductTab = dynamic(() => import('./product-tab'));
const VideoTab = dynamic(() => import('./video-tab'));

export default function PerformerContentTabs({ performer }: { performer: IPerformer }) {
  const [totalFeeds, setTotalFeeds] = useState(performer.stats.totalFeeds);
  const [totalVideos, setTotalVideos] = useState(performer.stats.totalVideos);
  const [totalGalleries, setTotalGalleries] = useState(performer.stats.totalGalleries);
  const [totalProducts, setTotalProducts] = useState(performer.stats.totalProducts);

  const items = [
    {
      key: 'post',
      label: <>
        <AiOutlineFire />
        <span className="tab-name">
          {totalFeeds > 0 && (
            <span className="tab-amount">
              {totalFeeds}
            </span>
          )}
          {totalFeeds > 1 ? ' POSTS' : 'POST'}
        </span>
      </>,
      children: <PostTab performer={performer} total={totalFeeds} setTotal={setTotalFeeds} />
    },
    {
      key: 'video',
      label: <>
        <AiOutlineVideoCamera />
        <span className="tab-name">
          {totalVideos > 0 && (
          <span className="tab-amount">
            {totalVideos}
          </span>
          )}
          {totalVideos > 1 ? ' VIDEOS' : 'VIDEO'}
        </span>
      </>,
      children: <VideoTab performer={performer} total={totalVideos} setTotal={setTotalVideos} />
    },
    {
      key: 'photo',
      label: <>
        <AiOutlinePicture />
        <span className="tab-name">
          {totalGalleries > 0 && (
          <span className="tab-amount">
            {totalGalleries}
          </span>
          )}
          {totalGalleries > 1 ? ' GALLERIES' : 'GALLERY'}
        </span>
      </>,
      children: <GalleryTab performer={performer} total={totalGalleries} setTotal={setTotalGalleries} />
    },
    {
      key: 'store',
      label: <>
        <AiOutlineShopping />
        <span className="tab-name">
          {totalProducts > 0 && (
          <span className="tab-amount">
            {totalProducts}
          </span>
          )}
          {totalProducts > 1 ? ' PRODUCTS' : 'PRODUCT'}
        </span>
      </>,
      children: <ProductTab performer={performer} total={totalProducts} setTotal={setTotalProducts} />
    }
  ];

  return (
    <Tabs
      defaultActiveKey="post"
      items={items}
      size="large"
    />
  );
}
